/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let BirthdayCakeO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M170.667008 568.889344v284.443648h682.665984V568.889344H170.667008z m0-56.889344h682.665984c31.419392 0 56.889344 25.469952 56.889344 56.889344v284.443648c0 31.419392-25.469952 56.889344-56.889344 56.889344H170.667008c-31.419392 0-56.889344-25.469952-56.889344-56.889344V568.889344c0-31.419392 25.469952-56.889344 56.889344-56.889344z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <Path
        d="M284.444672 398.222336V512h455.110656V398.222336H284.444672z m0-56.889344h455.110656c31.419392 0 56.889344 25.469952 56.889344 56.889344V512c0 31.418368-25.469952 56.889344-56.889344 56.889344H284.444672c-31.419392 0-56.889344-25.470976-56.889344-56.889344V398.222336c0-31.419392 25.469952-56.889344 56.889344-56.889344z"
        fill={getIconColor(color, 1, '#333333')}
      />
      <Path
        d="M512 227.555328c15.709184 0 28.444672 12.735488 28.444672 28.444672v113.777664c0 15.709184-12.735488 28.444672-28.444672 28.444672s-28.444672-12.735488-28.444672-28.444672V256c0-15.709184 12.735488-28.444672 28.444672-28.444672z m29.809664-91.952128c0 30.900224-15.5904 55.959552-34.816 55.959552s-34.816-25.059328-34.816-55.959552c0-30.900224 15.5904-55.958528 34.816-55.958528s34.816 25.058304 34.816 55.958528zM256 682.667008h512c15.709184 0 28.444672 12.734464 28.444672 28.443648 0 15.710208-12.735488 28.444672-28.444672 28.444672H256c-15.709184 0-28.444672-12.734464-28.444672-28.444672 0-15.70816 12.735488-28.443648 28.444672-28.443648z"
        fill={getIconColor(color, 2, '#333333')}
      />
    </Svg>
  );
};

BirthdayCakeO.defaultProps = {
  size: 18,
};

BirthdayCakeO = React.memo ? React.memo(BirthdayCakeO) : BirthdayCakeO;

export default BirthdayCakeO;
